import { useState, useRef, useCallback, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

export interface OrderDetails {
  id: string;
  kind: string;
  side: 'sell' | 'buy';
  status: string;
  tokenSetId: string;
  contract: string;
  maker: string;
  taker: string;
  price: {
    currency: {
      contract: string;
      name: string;
      symbol: string;
      decimals: number;
    };
    amount: {
      raw: string;
      decimal: number;
      usd: number;
      native: number;
    };
    netAmount: {
      raw: string;
      decimal: number;
      usd: number;
      native: number;
    };
  };
  validFrom: number;
  validUntil: number;
  quantityFilled: number;
  quantityRemaining: number;
  feeBps: number;
  feeBreakdown: Array<{
    kind: string;
    recipient: string;
    bps: number;
  }>;
  expiration: number;
  createdAt: string;
  updatedAt: string;
  source: {
    id: string;
    domain: string;
    name: string;
    icon: string;
    url: string;
  };
}

export interface CollectionInfo {
  address: string;
  name: string;
  image: string;
  ipfsBaseUrl?: string;
  imageExtension?: string;
}

export const COLLECTIONS: CollectionInfo[] = [
  {
    address: "0x5eDB0b26939764933c1ecFd99AB9379dfb62F4aD",
    name: "Frostbyte",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2Fi9YO%252F4yHXUdJsWcTqhqvf5oZLZVUq5xeS6gXFvUDeu05bnJVJsqKjrhD88RRU7ZjyIiBJg1JKFxAupZ3B0vn6pvNEt2KldEcoTcw9aQHHGTlKAMwoXzYzgDWs06TmBg5",
    ipfsBaseUrl: "https://ipfs.io/ipfs/Qmay6N4A29YrmEfDv4NqfhpqCspnMLx5318VD77AzJrCB4",
    imageExtension: "webp"
  },
  {
    address: "0x3f09FC57194809e5a02fACc90dD7021a51819C0D",
    name: "MONKEES",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2F7%252FrdF%252Fe%252F0iXY8HduhRCoIehkmFeXPeOQQFbbmIPfjCbAX%252B56YBbe6MGAOQcQOkiHjWWe4datLQ3NPU0hym8ja5XxqDM81nvLaUnUNhrL5dN80U28fOQ7FLwil%252FFUfohGRpin1uU%252BOmksG9x7LWhwJ8ugY0e%252FxmlBVp8Y%252BRMr62c%253D",
    ipfsBaseUrl: "https://ipfs.io/ipfs/QmY1hHrWgEYsWCfw7iaqV4CLYezuoSg9mh9w4urtDSHmnL",
    imageExtension: "png"
  },
  {
    address: "0x8954f7a8Eb01e94EfB10d610837f115Fe95aafb1",
    name: "RILLAZ",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2FM%252FK47YBCAs6ieLgkYDuIwv46DpQnevL2hmBULPkK3BtqIGsEAhHajfy53j%252BEJA57VIHHDJctyD%252BZhyq1y%252FI7V8M2%252FnLqQGvqA%252FpHF9nImf3Hj9D%252BWmudFdLNa7CuzZTt9xZN9rRqybNkL%252FKQSfKua7hjQFizXvA2mG%252BkiZ9gxri%252F%252FcyD%252BtjMRz202ruEBjxe7%252BCraYthpbYUeNVr0kOFlAS1ppY91hfJTUBnN9Dc%252Fw2Om%252FcwPI0oIQIX%252BWvW9%252FSG4whJCzuvZuqjjYMpbyjFsLQMvWzRUsRe7%252FitSQK8zkapoGWCoaj0IZ9aYCsAAKPlCPSKGmFBRellPlVdeq3w9IydqqV2681LNqGxRb1s0bOzGaPjBSCaRDlgtf1e5yVkwWTfn1DsHY8G%252Fu3ohqWmGg%253D%253D",
    ipfsBaseUrl: "https://ipfs.io/ipfs/bafybeihpxiggndecninxa2vg2iqu7wpiscyxbaaumfkblrmtkg5t7g4aru",
    imageExtension: "png"
  },
  {
    address: "0xd33edeC311f8769c71f132A77F0c0796c22AF1c5",
    name: "TokenGators",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2Fz9JRSpLYGu7%252BCZoKWtAuAIYpev452AQgX6bsora2mDdy4rWk9IqRe%252FkZQGmfDsTZU5TNTjJ2JfrGV2f4K9IJ0CAY%252FR587vOufEIauVjU1EQbi48ttLPRuky5gp0wy48zeXLD%252FdFXwgwIdU9SeQPuXw%253D%253D"
  },
  {
    address: "0xBEbaa24108d6a03C7331464270b95278bBBE6Ff7",
    name: "GobsOnApe",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExdW9pMTNkNndzOGRocGJ2NTNpcnpscDZnenRtMG1nYWV4dWd3ZXA2NCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/6wuw9uQfxzun7NfHbU/giphy.gif",
    ipfsBaseUrl: "https://bafybeihe3i3mtku2btovab3uwbggfjif2mi56gcztc4bimzijmt5iautku.ipfs.w3s.link",
    imageExtension: "svg"
  },
  {
    address: "0x2CF92fe634909A9cF5e41291f54e5784d234cF8d",
    name: "Dengs",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExdGxwejg2czhzbDh5eDJ4bzhsMGowOXRjejliODVnb3Vmcnh6ZGl5ciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/NswTQ4hxbyYnztGoJF/giphy.gif",
    ipfsBaseUrl: "https://ipfs.io/ipfs/bafybeiem37xxbnxaevccwdsiexu4qpop2mqj6dlkneghs7n4gldn6jw2lm",
    imageExtension: "png"
  },
  {
    address: "0xB3A12aa155DCd85d7aeD8acb6347761a7C7ecf83",
    name: "The Mich Khan",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2Fhc%252BnPcLmWxs%252FDW99DlBQ42k40ZoyYV5jCIms5qHjwvtuWzZFhayu%252BPyZKPYgmVeetBOsk9AwbvfjdXroUmqF1HlzAqSlJVjuKQ%252BonsTdUs%252F9xw1v7HGXhzs8HF0QXL%252Bq2UcAI4sUYajgyuyrlcbU8JL6PYnlUwGyB7Uj%252FBxu2t3zq50DdknG90%252BHcusjnATbTe9lHnhFgrwsnL9uV%252F49FQ%253D%253D",
    ipfsBaseUrl: "https://ipfs.io/ipfs/QmTYBXMHzDHGA8bBBGpZskVFVGUVHy3Emh1cem9fjUXkSw",
    imageExtension: "webp"
  },
  {
    address: "0xb3443B6Bd585ba4118CaE2beDb61c7EC4a8281Df",
    name: "Gs on Ape",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2FajjEJwOmVw1KWK2WSUR6lYj2SmnLfs8Sc2mF5pOnfO8uAuubZUK2gjjAlH32XWFd6wwPbQwLENuCbWcMahnvUc%252FWHLj2DsG5gDoeiaYvH5Ws2PUhfJ3oxywT8tCdZ5tYX%252ByqQ8pDhYEYB3n3LZ0oSg%253D%253D",
    ipfsBaseUrl: "https://bafybeifrjmhpuf34cv6sy4lqhs5gmmusznpunyfik3rqoqfi73abpcpnbi.ipfs.w3s.link",
    imageExtension: "jpg"
  }
];

export type SortOption = 'price_asc' | 'price_desc' | 'time_asc' | 'time_desc';

const getListingImageUrl = (collection: CollectionInfo | undefined, tokenId: string) => {
  if (!collection) return '';
  
  if (collection.ipfsBaseUrl) {
    // For Frostbyte collection, increment the token ID by 1
    if (collection.name === "Frostbyte") {
      const adjustedTokenId = (parseInt(tokenId) + 1).toString();
      return `${collection.ipfsBaseUrl}/${adjustedTokenId}.${collection.imageExtension}`;
    }
    // For all other collections with IPFS
    return `${collection.ipfsBaseUrl}/${tokenId}.${collection.imageExtension}`;
  }
  
  return collection.image;
};

const fetchListingsForCollection = async (collection: CollectionInfo): Promise<OrderDetails[]> => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

    const response = await fetch(
      `https://api-mainnet.magiceden.dev/v3/rtp/apechain/orders/asks/v5?contracts=${collection.address}&normalizeRoyalties=false&sortBy=updatedAt&limit=50&includeCriteriaMetadata=true&includeRawData=true`,
      {
        headers: {
          'accept': '*/*'
        },
        signal: controller.signal
      }
    );

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.orders || [];
  } catch (error) {
    console.error(`Error fetching listings for ${collection.name}:`, error);
    return []; // Return empty array instead of throwing
  }
};

export function useListingsQueue(
  selectedCollections?: string[],
  sortOption: SortOption = 'time_desc',
  filters: {
    minPrice?: number;
    maxPrice?: number;
  } = {}
) {
  const [failedCollections, setFailedCollections] = useState<string[]>([]);
  const [currentCollection, setCurrentCollection] = useState<string>('All Collections');
  const cacheRef = useRef<Record<string, { data: OrderDetails[]; timestamp: number }>>({});

  const fetchListings = useCallback(async () => {
    const collectionsToFetch = selectedCollections
      ? COLLECTIONS.filter(c => selectedCollections.includes(c.address))
      : COLLECTIONS;

    const now = Date.now();
    const allListings: OrderDetails[] = [];
    const newFailedCollections: string[] = [];

    await Promise.all(
      collectionsToFetch.map(async (collection) => {
        try {
          const listings = await fetchListingsForCollection(collection);
          allListings.push(...listings);
        } catch (error) {
          console.error(`Failed to fetch ${collection.name}:`, error);
          newFailedCollections.push(collection.name);
        }
      })
    );

    setFailedCollections(newFailedCollections);
    return allListings;
  }, [selectedCollections]);

  const { data: listings = [], isLoading, error, refetch } = useQuery({
    queryKey: ['listings-queue', selectedCollections, sortOption, filters],
    queryFn: fetchListings,
    refetchInterval: 15000,
    staleTime: 10000,
    gcTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: attempt => Math.min(1000 * Math.pow(2, attempt), 30000),
  });

  // Apply filters
  const filteredListings = listings.filter(listing => {
    if (filters.minPrice && listing.price.amount.decimal < filters.minPrice) return false;
    if (filters.maxPrice && listing.price.amount.decimal > filters.maxPrice) return false;
    return true;
  });

  // Sort listings
  const sortedListings = [...filteredListings].sort((a, b) => {
    switch (sortOption) {
      case 'price_asc':
        return a.price.amount.decimal - b.price.amount.decimal;
      case 'price_desc':
        return b.price.amount.decimal - a.price.amount.decimal;
      case 'time_asc':
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      case 'time_desc':
      default:
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    }
  });

  // Update current collection name
  useEffect(() => {
    if (selectedCollections?.length === 1) {
      const collection = COLLECTIONS.find(c => c.address === selectedCollections[0]);
      setCurrentCollection(collection?.name || 'All Collections');
    } else if (selectedCollections?.length > 1) {
      setCurrentCollection(`${selectedCollections.length} Collections`);
    } else {
      setCurrentCollection('All Collections');
    }
  }, [selectedCollections]);

  return {
    listings: sortedListings,
    failedCollections,
    isLoading: isLoading && sortedListings.length === 0,
    error,
    currentCollection,
    refetch,
    getListingImageUrl
  };
}